import * as React from "react";

import "./numericinput.scss";

export enum NumericInputType {
    Step,
    Dropdown
}

interface INumericInputProps {
    max: number,
    min: number,
    value: number,
    onChange: (value: number, attributes?: number[]) => void,
    style?: React.CSSProperties,
    attributes?: number[],
    suffix?: string,
    type?: NumericInputType
}

interface INumericInputState {
    value: number
}

export class NumericInput extends React.Component<INumericInputProps, INumericInputState> {

    constructor (props: INumericInputProps) {
        super(props);

        this.props = props;

        this.handleChange = this.handleChange.bind(this);
        this.handleDecrease = this.handleDecrease.bind(this);
        this.handleIncrease = this.handleIncrease.bind(this);

        this.state = {
            value: props.value
        }
    }

    componentWillReceiveProps(nextProps: INumericInputProps) {
        if (nextProps.value !== this.props.value)
            this.setState({
                value: nextProps.value
            });
    }

    handleChange(e: any) {
        let v = e.currentTarget.value;

        if (v == null)
            return;

        this.setState({
            value: v.replace(/[^0-9]/g, '')
        });

        this.props.onChange(v, this.props.attributes);
    }

    handleDecrease(e: any) {
        let newValue = this.props.value - 1;

        this.props.onChange(newValue, this.props.attributes);
    }

    handleIncrease(e: any) {
        let newValue = this.props.value + 1;

        this.props.onChange(newValue, this.props.attributes);
    }

    render() { 

        if (this.props.min === this.props.max || this.props.min > this.props.max)
            return <span></span>;

        if (this.props.type === NumericInputType.Dropdown) {

            let options: JSX.Element[] = [];
            for (let i=this.props.min; this.props.max >= i; i++) {
                options.push(<option value={i}>{i} {this.props.suffix}</option>)
            }

            return <span className="ncb-shared-numericInput" style={this.props.style}>
                <select value={this.props.value} onChange={this.handleChange}>
                    {options}
                </select>
            
            </span>
        }

        let isMinReached = this.props.value <= this.props.min;
        let isMaxReached = this.props.value >= this.props.max;

        return <span className="ncb-shared-numericInput" style={this.props.style}>
            <span onClick={isMinReached ? null : this.handleDecrease} data-is-disabled={isMinReached}>-</span>
            {(this.props.suffix) ? <span className="ncb-shared-numericInput-value">{this.props.value} {this.props.suffix}</span> : <input type="text" max={this.props.max} min={this.props.min} onChange={this.handleChange} value={this.props.value} />}
            <span onClick={isMaxReached ? null : this.handleIncrease} data-is-disabled={isMaxReached}>+</span>
        </span>
    }
}


// WEBPACK FOOTER //
// ./src/components/shared/numericInput.tsx